
































import { Component, Prop, Ref, Vue } from "vue-property-decorator";

@Component
export default class AutoCompleteTextField extends Vue {
  @Prop({ default: "", type: String }) value!: string;
  @Prop({ default: () => [] }) options!: string[];
  @Ref("matching-list") matchingList!: HTMLDivElement;

  matchingEntries: string[] = [];
  listWidth: string = "300px";
  currentlySelected: number = 0;

  mutableValue: string = "";
  onInput() {
    this.listWidth =
      (this.matchingList.getBoundingClientRect().width ||
        this.matchingList.clientWidth) + "px";

    this.matchingEntries =
      this.mutableValue !== ""
        ? this.options.filter(entry => entry.includes(this.mutableValue))
        : [];

    this.$emit("input", this.mutableValue);
  }
  closeSuggestions() {
    setTimeout(() => {
      this.matchingEntries = [];
    }, 250);
  }
  isActive(indexValue: string) {
    return indexValue === this.matchingEntries[this.currentlySelected];
  }
  changeSelected(value: number) {
    const toChangeValue = this.currentlySelected + value;
    if (
      toChangeValue >= 0 &&
      toChangeValue <= this.matchingEntries.length - 1
    ) {
      this.currentlySelected = toChangeValue;
      this.matchingList
        .getElementsByTagName("li")
        [this.currentlySelected].setAttribute("class", "active");
    }
    this.matchingList
      .getElementsByTagName("li")
      [this.currentlySelected].scrollIntoView();
  }
  assignSuggestionOnEnter() {
    this.assignSuggestion(this.matchingEntries[this.currentlySelected]);
  }
  assignSuggestion(entry: string) {
    if (!entry) {
      return;
    }
    this.mutableValue = entry;
    this.$emit("input", this.mutableValue);
    this.matchingEntries = [];
    this.currentlySelected = 0;
  }
  async mounted() {
    this.mutableValue = this.value;
  }
}
